// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: "https://cmed.ci/coursier-admin",
  // apiUrl: "https://umrahmall.org/santeya/api",
  apiUrl: "https://life.techtrial.work/tt-life/api",
  // imageUrl: "https://umrahmall.org/santeya",
  imageUrl: "https://life.techtrial.work/tt-life",
  google: "589199753824-rejld1u2e9iqgnqodj9qvc0q7kbir554.apps.googleusercontent.com",
  facebook: "477318317055901",
  zoom_api_key: "XvjlbiiOR5KYCoGpb1ngoA",
  paypal_client_id: "AWwCuC98kyL8tnJW6zwfunWjlbLqa4jWA_nTy7q8USoqPDtZKkfJS9gBseMpex6KiiQ7Fy6SrHTJ-r7o",
  firebase: {
    apiKey: "AIzaSyDjWlVqdG8rVQxGtGdjtmp2tgMgJD8bmsk",
    authDomain: "techtrial-taxi.firebaseapp.com",
    projectId: "techtrial-taxi",
    storageBucket: "techtrial-taxi.appspot.com",
    messagingSenderId: "161097084830",
    appId: "1:161097084830:web:cc7f038017b0d31edd308f",
    measurementId: "G-EZS6BNEZD1"
  }
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
